import Breadcrumb from "../components/Breadcrumb";
import WorkflowsLayer from "../components/WorkflowsLayer";
import WorkFlowsSuggestionLayer from "../components/WorkFlowsSuggestionLayer";

const WorkFLowsSuggestionPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Workflows Suggestions" />

      < WorkFlowsSuggestionLayer/>
    </>
  );
};

export default WorkFLowsSuggestionPage;
